// extracted by mini-css-extract-plugin
module.exports = {"content":"landing_content_2VSHN","actions":"landing_actions_1c7sK"};